import api from '../services/ApiService';
import EventBus from '../services/EventBus';

export default {
    namespaced: true,
    state: {
        isLoggedIn: false,
        token: null,
        data: {id:0,name:''},
        blogs: [],
        follows: [],
        tumblrAuth: {},
        unreadMessages: 0
    },
    getters: {
        token(state){
           return state.token;
        },
        isLoggedIn(state){
            return state.isLoggedIn;
        },
        follows(state){
            return state.follows
        },
        id(state){
            return state.data.id;
        },
        name(state){
            return state.data.name;
        },
        blogs(state){
            return state.blogs;
        },
        tumblrAuth(state){
            return state.tumblrAuth;
        },
        unreadMessages(state){
            return state.unreadMessages;
        }
    },
    mutations: {
        setToken(state, token){
            localStorage.setItem('token', token);
            state.isLoggedIn = true;
            state.token = token;
            this.dispatch('user/updateBlogs');
        },
        unsetToken(state){
            localStorage.removeItem('token');
            state.isLoggedIn = false;
            state.token = null;
            EventBus.$emit('user.logout');
        },
        setData(state, data){
            state.data.id = data._id;
            state.data.name = data.name
        },
        updateBlogs(state, blogs){
            state.blogs = blogs;
        },
        userFollows(state, followedBlogs){
            state.follows = followedBlogs;
        },
        tumblrAuth(state, auth){
            state.tumblrAuth = auth;
        },
        setUnreadMessages(state, messageCount){
            state.unreadMessages = messageCount;
        }
    },
    actions: {
        init(ctx, token){
            return api.getUserInfo(token).then((res)=>{
                ctx.commit('setToken', res.data.token);
                ctx.commit('setData', res.data.user);
                ctx.commit('userFollows', res.data.user.follows);
                localStorage.setItem('token', res.data.token);
                EventBus.$emit('user.login');
            });
        },
        updateBlogs(ctx){
            api.getUserBlogs().then((res)=>{
                ctx.commit('updateBlogs', res.data.blogs);
            })
        },
        followBlog(ctx, blogUrl){
            api.toggleFollowBlog(blogUrl).then((res)=>{
                ctx.commit('userFollows', res.data.follows);
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/user.js